// frontend_react/src/components/AdminPanel/CreateClientPanel.jsx

import React, { useState } from "react";
import styled from "styled-components";
import { AdminButton } from "../../pages/admin/action_engine";
import { createClient } from "../../services/adminApi";
import logger from "../../utils/logger";

import {
  AdminActions,
} from "../../pages/admin/section_engine";

const EMPTY_FORM = {
  firstname: "",
  lastname: "",
  email: "",
  phone_number: "",
  address: "",
  postal_code: "",
  city: "",
  country: "France",
};

export default function CreateClientPanel() {
  const [form, setForm] = useState(EMPTY_FORM);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setForm(EMPTY_FORM);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage("");
    setError("");

    const payload = {
      name: `${form.firstname.trim()} ${form.lastname.trim()}`,
      firstname: form.firstname.trim(),
      lastname: form.lastname.trim(),
      email: form.email.trim(),
      phone_number: form.phone_number.trim(),
      address: form.address.trim(),
      postal_code: form.postal_code.trim(),
      city: form.city.trim(),
      country: form.country.trim(),
    };

    try {
      await createClient(payload);
      setMessage("Client créé. Un e-mail de définition du mot de passe a été envoyé.");
      resetForm();
    } catch (err) {
      logger.error(err);
      setError(
        err?.response?.data?.error ||
          err?.response?.data?.msg ||
          "Erreur lors de la création du client."
      );
    }
  };

  return (
    <Wrapper>
      {message && <PanelMessage>{message}</PanelMessage>}
      {error && <PanelMessage $error>{error}</PanelMessage>}

      <FormCard onSubmit={handleSubmit}>
        <CardTitle>Nouveau compte client</CardTitle>

        <FieldGrid>
          <Field>
            <label>Prénom *</label>
            <input
              name="firstname"
              value={form.firstname}
              onChange={handleChange}
              required
            />
          </Field>

          <Field>
            <label>Nom *</label>
            <input
              name="lastname"
              value={form.lastname}
              onChange={handleChange}
              required
            />
          </Field>
        </FieldGrid>

        <Field>
          <label>E-mail *</label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            required
          />
        </Field>

        <Field>
          <label>Téléphone *</label>
          <input
            type="tel"
            name="phone_number"
            value={form.phone_number}
            onChange={handleChange}
            required
          />
        </Field>

        <Field>
          <label>Adresse *</label>
          <input
            name="address"
            value={form.address}
            onChange={handleChange}
            required
          />
        </Field>

        <FieldGrid>
          <Field>
            <label>Code postal *</label>
            <input
              name="postal_code"
              value={form.postal_code}
              onChange={handleChange}
              required
            />
          </Field>

          <Field>
            <label>Ville *</label>
            <input
              name="city"
              value={form.city}
              onChange={handleChange}
              required
            />
          </Field>
        </FieldGrid>

        <Field>
          <label>Pays *</label>
          <input
            name="country"
            value={form.country}
            onChange={handleChange}
            required
          />
        </Field>

        <AdminActions $compact>
          <AdminButton type="submit" variant="success" fullWidth>
            Créer le client
          </AdminButton>

          <AdminButton type="button" variant="ghost" fullWidth onClick={resetForm}>
            Réinitialiser
          </AdminButton>
        </AdminActions>
      </FormCard>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  color: #f7f7f7;
`;

const FormCard = styled.form`
  display: grid;
  gap: 0.8rem;
  padding: 1rem;
  border-radius: 16px;
  background: #202a43;
  border: 1px solid rgba(255, 255, 255, 0.08);
`;

const CardTitle = styled.h4`
  margin: 0 0 0.3rem;
  font-size: 1rem;
  font-weight: 950;
`;

const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
`;

const Field = styled.div`
  display: grid;
  gap: 0.35rem;

  label {
    font-size: 0.78rem;
    font-weight: 850;
    opacity: 0.82;
  }

  input {
    width: 100%;
    border: none;
    border-radius: 10px;
    padding: 0.75rem;
    background: #fff9ea;
    color: #0b1328;
    font-weight: 750;
    box-sizing: border-box;
    outline: none;
  }
`;

const PanelMessage = styled.div`
  margin-bottom: 1rem;
  padding: 0.85rem 1rem;
  border-radius: 12px;
  font-weight: 850;
  background: ${({ $error }) =>
    $error ? "rgba(180, 40, 40, 0.9)" : "rgba(40, 140, 80, 0.9)"};
`;